import { render, staticRenderFns } from "./AddEditDeclaredValueModal.vue?vue&type=template&id=c9bd87b0"
import script from "./AddEditDeclaredValueModal.vue?vue&type=script&lang=ts"
export * from "./AddEditDeclaredValueModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports